import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
    standalone: true,
    selector: '[qwykTableTemplate]',
})
export class QwykTableTemplateDirective {
    @Input('qwykTableTemplate') name: string;

    constructor(public template: TemplateRef<unknown>) {}
}
